require('./bootstrap');

import Alpine from 'alpinejs';
import tippy, {createSingleton} from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling

window.Tippy = tippy;
window.Alpine = Alpine;

Alpine.start();

const tippyInstances = tippy('[data-tippy-content]');
createSingleton(tippyInstances, {
    delay: [300, 0],
    moveTransition: 'transform 0.2s ease-out',
})
